import { Button, Col, ColorPicker, Input, Row, Space, Switch, Typography } from 'antd';
import '../../ExpandedMapView/ExpandedMapView.scss';
import './ToolBoxTab.scss';

const { Text } = Typography;

interface ToolBoxTabProps {
  openSettings: (toolType: string) => void;
  settings: any;
  updateSettings: (key: any, value: any) => void;
  columns: any;
  setColumns: (value: any) => void;
}

const ToolBoxTab: React.FC<ToolBoxTabProps> = ({ openSettings, settings, updateSettings, columns }) => {
  function deepEqual(a: any, b: any): boolean {
    if (a === b) return true;

    if (Array.isArray(a) && Array.isArray(b)) {
      if (a.length !== b.length) return false;
      return a.every((element, index) => deepEqual(element, b[index]));
    }

    if (typeof a === 'object' && typeof b === 'object' && a !== null && b !== null) {
      const aKeys = Object.keys(a);
      const bKeys = Object.keys(b);
      if (aKeys.length !== bKeys.length) return false;
      return aKeys.every((key) => deepEqual(a[key], b[key]));
    }

    return false;
  }

  const equals = deepEqual(columns?.querySelectedColumns, columns?.proximitySelectedColumns);
  console.log(settings?.queryTool?.enabled);
  return (
    <Space direction="vertical" size="middle" className="toolbox-tab__container">
      {/* Query  */}
      <Space direction="vertical" size="small" className="proximity-tool-box">
        <Row justify="space-between" align="middle">
          <Col>
            <Text className="toolbox-text" strong>
              Query Tool
            </Text>
          </Col>
          <Col>
            <Space>
              <Text className="toolbox-text">OFF</Text>
              <Switch value={settings?.queryTool?.enabled} onChange={(checked) => updateSettings('queryTool.enabled', checked)} />
              <Text className="toolbox-text">ON</Text>
            </Space>
          </Col>
        </Row>
        {settings?.queryTool?.enabled && (
          <>
            <Row justify="space-between" align="middle">
              <Col>
                <Space>
                  <Text className="toolbox-text">Tool Name:</Text>
                  <Input
                    value={settings?.queryTool?.name}
                    onChange={(e) => updateSettings('queryTool.name', e.target.value)}
                    className="toolbox-tab__name-input"
                  />
                </Space>
              </Col>
              <Col>
                <Space>
                  <Button onClick={() => openSettings('query')}>Settings</Button>
                  <Button disabled={equals}>Sync to Proximity Tool</Button>
                </Space>
              </Col>
            </Row>
            <Row align="middle">
              <Space>
                <Text className="toolbox-text">Highlight Colour:</Text>
                <ColorPicker
                  className="custom-button"
                  value={settings?.queryTool?.color}
                  onChange={(color) => updateSettings('queryTool.color', color.toHexString())}
                  showText
                />
              </Space>
            </Row>
          </>
        )}
      </Space>

      {/* Proximity */}
      <Space direction="vertical" size="small" className="toolbox-tab__section">
        <Row justify="space-between" align="middle">
          <Col>
            <Text className="toolbox-text" strong>
              Proximity Tool
            </Text>
          </Col>
          <Col>
            <Space>
              <Text className="toolbox-text">OFF</Text>
              <Switch value={settings?.proximityTool?.enabled} onChange={(checked) => updateSettings('proximityTool.enabled', checked)} />
              <Text className="toolbox-text">ON</Text>
            </Space>
          </Col>
        </Row>
        {settings?.proximityTool?.enabled && (
          <>
            <Row justify="space-between" align="middle">
              <Col>
                <Space>
                  <Text className="toolbox-text">Tool Name:</Text>
                  <Input
                    value={settings?.proximityTool?.name}
                    onChange={(e) => updateSettings('proximityTool.name', e.target.value)}
                    className="toolbox-tab__name-input"
                  />
                </Space>
              </Col>
              <Col>
                <Space>
                  <Button onClick={() => openSettings('proximity')}>Settings</Button>
                  <Button disabled={equals}>Sync to Query Tool</Button>
                </Space>
              </Col>
            </Row>
            <Row align="middle">
              <Space>
                <Text className="toolbox-text">Highlight Colour:</Text>
                <ColorPicker
                  className="custom-button"
                  value={settings?.proximityTool?.color}
                  onChange={(color) => updateSettings('proximityTool.color', color.toHexString())}
                  showText
                />
              </Space>
            </Row>
          </>
        )}
      </Space>
    </Space>
  );
};

export default ToolBoxTab;
